import styled from "styled-components";
import {  SharedOutlineProps, SharedOutlineStyles } from "../ReusableStyledComponents/outline";
import { V3Caption } from "../Typography";
import { AuthoryColorSchemeProps, UserThemableHeading } from "../ReusableStyledComponents/FontSetUtilities";

export const EditableContentWrapper = styled.div<SharedOutlineProps & {
    $smallPadding: boolean,
    $customBorderRadius: string,
    $dashOnHover: boolean,
    $editMode: boolean,
    $isInline: boolean,
}>`
    border-radius: ${({ $customBorderRadius }) => $customBorderRadius};
    padding: ${({ $smallPadding }) => $smallPadding ? "4px" : "14px 20px"};
    cursor: pointer;
    display:${({ $isInline }) => $isInline ? "inline-flex" : "block"};
    text-align: center;

    ${SharedOutlineStyles}

    > * {
        pointer-events: ${({ $editMode }) => $editMode ? "none" : undefined};
    }
`;

export const UserThemableUIElementCaption = styled(V3Caption)<AuthoryColorSchemeProps>`
    ${UserThemableHeading};
`;